import { Link } from "react-router-dom";

export const MenuItem = ({ path, desc, handleToggle }) => {
    return (
        <Link to={path} className="my-3" onClick={handleToggle}>{desc}</Link>
    );
};